import { render, staticRenderFns } from "./ChangePasswordWithVerification.vue?vue&type=template&id=451c4864"
import script from "./ChangePasswordWithVerification.vue?vue&type=script&lang=js"
export * from "./ChangePasswordWithVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports